import { signal } from '@angular/core';

/**
 * Estado compartido entre el <app-header> y el dashboard.
 * Controla si se está mostrando la vista tipo Mapa o tipo Tarjetas.
 */
export const isMapView = signal<boolean>(true);